var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSmallWarn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "govh1advoa",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2813",
    transform: "translate(-607 -594)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 502",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(607 594)",
    style: {
      fill: "url(#govh1advoa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3761",
    d: "M5618.3 306.633v5.49",
    transform: "translate(-5002.707 295.051)",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3762",
    d: "M5618.3 306.633v.005",
    transform: "translate(-5002.707 291.582)",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSmallWarn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-smallWarn.7df5afd564109e210ee366d5a67acd9f.svg";